// FilterBar — pill-фильтры уведомлений.
// Тактильный редизайн «Картотека»: pill-чипы (горизонтальный скролл на узком
// viewport), активный — заполнен primary; всё через токены §3.

import { SegmentedControl } from "@studyhub/ui/components/segmented-control";
import { useTranslation } from "react-i18next";
import { useCommerceVisible } from "@/lib/module-availability/commerce";

export type NotificationFilter = "all" | "ai" | "billing" | "streak" | "system";

const FILTERS: readonly NotificationFilter[] = ["all", "ai", "billing", "streak", "system"];

interface FilterBarProps {
	value: NotificationFilter;
	onValueChange: (v: NotificationFilter) => void;
}

export function FilterBar({ value, onValueChange }: FilterBarProps) {
	const { t } = useTranslation("notifications");
	const commerceVisible = useCommerceVisible();
	// Фильтр «Оплата» — только там, где оплата видна (не в приложении из App
	// Store, guideline 3.1.1).
	const filters = commerceVisible ? FILTERS : FILTERS.filter((f) => f !== "billing");

	return (
		<SegmentedControl
			scrollable
			aria-label={t("filters.all")}
			value={value}
			onValueChange={onValueChange}
			options={filters.map((f) => ({ value: f, label: t(`filters.${f}`) }))}
		/>
	);
}
